module.exports = __webpack_public_path__ + "static/media/Fabrication EstMEP.73827eba.png";